import {
  ConfirmationRuleReturn,
  ConfirmationRuleReturnNodeId,
} from '~/models/FormContentTypeManagement';
import { FormRule } from '~/models/FormContentType';

/**
 * Form Content Type assertion functions
 */
export class FormContentTypeAssertions {
  static isNodeIdReturnRule = (
    rule: FormRule<ConfirmationRuleReturn>
  ): rule is FormRule<ConfirmationRuleReturnNodeId> =>
    rule?.return && 'link' in rule.return ? true : false;
}
